import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  key: 2,
  class: "ms-1 align-middle"
}

import ELROND from "@/constants/elrond";
import { computed } from "vue";
import formatterHelper from "../helpers/formatter";
import BLOCKCHAIN from '@/constants/blockchain';
import { TokenTransfer } from '@multiversx/sdk-core/out';
import { BigNumber } from "bignumber.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenImage',
  props: {
    token: {},
    amount: {},
    noName: { type: Boolean },
    textClass: {},
    decimals: {},
    round: { type: Boolean },
    notFullToken: { type: Boolean },
    noImage: { type: Boolean },
    formatTokenOnly: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const imageUrl = computed(() => {
  if (ELROND.EGLD_TOKEN === props.token) {
    return require(`../assets/images/tokens/EGLD.png`);
  }

  if (BLOCKCHAIN.TOKEN_IDENTIFIER === props.token) {
    return require(`../assets/images/tokens/NUTS.svg`);
  }

  if (props.token.startsWith('VIP')) {
    return require(`../assets/images/tokens/VIP.png`);
  }
  
  if (props.token.includes('NUTSWEGLD')) {
    return require(`../assets/images/tokens/NUTSWEGLD.png`);
  }

  return ELROND.TOKEN_LOGO.replace("{TOKEN}", BLOCKCHAIN.TOKENS[props.token]?.logo || props.token);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.amount)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass('me-1 align-middle ' + _ctx.textClass)
        }, _toDisplayString(_unref(formatterHelper).formatTokenTransfer(_ctx.amount, _ctx.decimals || 8, _ctx.notFullToken ? null : (_ctx.formatTokenOnly ? _unref(formatterHelper).formatToken(_ctx.token) : _ctx.token), _ctx.round)), 3))
      : _createCommentVNode("", true),
    (!_ctx.noImage)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: imageUrl.value,
          alt: _unref(formatterHelper).formatToken(_ctx.token),
          class: "img-token-sm align-middle"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (!_ctx.amount && !_ctx.noName)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.formatTokenOnly ? _unref(formatterHelper).formatToken(_ctx.token) : _ctx.token.split('-')[0]), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})